import { PageTemplate } from '@spa/lib/cms/const';

export type PageType =
  | 'home'
  | 'produktdetail'
  | 'warenkorb'
  | 'checkout'
  | 'danke'
  | 'suche'
  | 'marken'
  | 'kategorie'
  | 'smart-kategorie'
  | 'login'
  | 'kundenkonto'
  | 'wunschliste'
  | 'prospekte'
  | 'storefinder'
  | 'content'
  | 'service'
  | 'not-defined';

export interface PageTypeOptions {
  pageTemplate?: PageTemplate;
  pathname: string;
}

function getPageType({ pathname, pageTemplate }: PageTypeOptions): PageType {
  const path: string = pathname.toLowerCase();
  const isRoot: boolean = path === '/';
  const has = (s: string): boolean => path.includes(s);

  let pageType: PageType | undefined;

  switch (true) {
    case pageTemplate === PageTemplate.SMART_CATEGORY_PLP:
      pageType = 'smart-kategorie';
      break;
    case isRoot:
      pageType = 'home';
      break;
    case has('/checkout/confirmation/'):
      pageType = 'danke';
      break;
    case has('/checkout/') && !has('/confirmation/'):
      pageType = 'checkout';
      break;
    case has('/p/'):
      pageType = 'produktdetail';
      break;
    case has('/cart/'):
      pageType = 'warenkorb';
      break;
    case has('/search/'):
      pageType = 'suche';
      break;
    case has('/b/'):
      pageType = 'marken';
      break;
    case has('/c/'):
      pageType = 'kategorie';
      break;
    case has('/my-account/wishlists/'):
      pageType = 'wunschliste';
      break;
    case has('/auth/login-register/') || has('/account/register/'):
      pageType = 'login';
      break;
    case has('/my-account/') && !has('/wishlists/'):
      pageType = 'kundenkonto';
      break;
    case has('/prospekte/'):
      pageType = 'prospekte';
      break;
    case has('/storefinder/'):
      pageType = 'storefinder';
      break;
    case has('/aktuelles/') || has('/meinbaby/'):
      pageType = 'content';
      break;
    case has('/unternehmen/') || has('/service/') || has('/kontakt/') || has('/newsletter/'):
      pageType = 'service';
      break;
    default:
      pageType = 'not-defined';
  }

  return pageType;
}

export default getPageType;
